import { createSelector } from '@reduxjs/toolkit';
import { Media } from '../../backend_api/models';
import { AppState } from '../../base/types';

const videoResourceSelector = (state: AppState): Media => state.app.VIDEO.video;

export const getVideoResource = createSelector(
    [videoResourceSelector],
    (video) => video,
);